import React, { useEffect, useRef } from 'react';
import { freeTrialTermsText } from '../../functions/src/common/freeTrialTerms';

const styles = {
    dialog: 'onboarding-theme m-auto w-[calc(100%-2rem)] max-w-2xl max-h-[calc(100dvh-2rem)] rounded-2xl border border-slate-200 bg-white p-6 text-slate-900 shadow-2xl backdrop:bg-slate-950/60',
    text: 'whitespace-pre-wrap text-sm leading-6 text-slate-700',
    button: 'rounded-xl bg-blue-600 px-5 py-3 text-sm font-bold text-white hover:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
};

const FreeTrialTermsModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const dialog = useRef<HTMLDialogElement>(null);
    useEffect(() => {
        const element = dialog.current;
        element?.showModal();
        return () => element?.close();
    }, []);
    return <dialog ref={dialog} aria-labelledby="free-trial-terms-title" onClose={event => !event.currentTarget.open && onClose()} className={styles.dialog}>
        <div className="flex max-h-[calc(100dvh-5rem)] flex-col gap-5">
            <h2 id="free-trial-terms-title" className="text-xl font-extrabold">Evaluation Terms and Confidentiality</h2>
            <div tabIndex={0} role="region" aria-label="Free trial terms" className={`${styles.text} min-h-0 overflow-y-auto`}>{freeTrialTermsText()}</div>
            <div className="flex justify-end"><button autoFocus type="button" onClick={onClose} className={styles.button}>Understood</button></div>
        </div>
    </dialog>;
};

export default FreeTrialTermsModal;
